import Link from '../../views/Datafactorymanagement';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  membername: state.shift.assessment.membername,
  memberusername: state.shift.assessment.memberusername,
  memberemail: state.shift.assessment.memberemail,
  membertelephone: state.shift.assessment.membertelephone,
  memberrole: state.shift.assessment.memberrole,
  memberstatus: state.shift.assessment.memberstatus,
  nextaction: state.shift.assessment.nextaction,
  popwindow: state.shift.status.popwindow,
  username: state.shift.auth.username,
  customerdfList:state.shift.assessment.customerdfList,
  customer: state.shift.assessment.customer,
  customerid: state.shift.auth.customerid,
  usersList: state.shift.assessment.usersList,
  customersList:state.shift.assessment.customersList,
  getCustomerdfList:state.shift.assessment.getCustomerdfList,
  role: state.shift.auth.role
});
const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;
  return {

    docheckddlexist: (customerid,projectname,page,fun) => {
      console.log(customerid)
      // alert(customerid);
      // alert(projectname);
      dispatch(actions.checkddlexist(customerid,projectname,'DDLPage')).then(
        res => {
        if(res.value.code == "200"){
         
          fun({disablepr:false});
        
        }else{
          fun({disablepr:true});
        }
      }
      );
    },

    getusersList: username => {
      dispatch(actions.usersList(username));
    },

    getCustomers: ()=>{
      dispatch(actions.customersList());
    },

    getCustomerdfList:customer =>{ 
     dispatch(actions.customerdfList(customer));
    //  getCustomerdfList:(customer,fun) =>{ 
    //   dispatch(actions.customerdfList(customer)).then((res)=>{fun({dfs:res.value.data})});
     },

// no dropdown use customerid

    inviteUser: (
      firstName,
      lastName,
      email,
      phoneNumber,
      adminUsername,
      role,
      fun
    ) => {
      dispatch(
        actions.register(
          firstName,
          lastName,
          email,
          phoneNumber,
          adminUsername,
          role
        )
      ).then(() => fun());
    },

    gotoDatafactorycreation: () => {
      dispatch(push(`/${locale}/createdatafactory/`));
      //dispatch(push(`/${locale}/dashboard`));
    },

    gotoDatafactorycreation2: () => {
      dispatch(push(`/${locale}/createdatafactory/dfs`));
      //dispatch(push(`/${locale}/dashboard`));
    },


    deleteUser: (username, email, adminUsername, props, selectItem) => {
      dispatch(actions.unregister(username, email, adminUsername)).then(
        setTimeout(() => {
          // selectItem({});
          // props.getusersList(username)
          window.location.reload()();
        }, 1000)
      );
    },

    gotoManagementDFuser: ()=>{
      dispatch(push(`/${locale}/managementDFuser`));
    },
    clickBackHandler: value => {
      dispatch(push(`/${locale}/shift`));  
      //dispatch(push(`/${locale}/`));
    },

    gotoManagementDDL: ()=>{
      dispatch(push(`/${locale}/managementDDL`));
    },
    clickBackHandler: value => {
      dispatch(push(`/${locale}/shift`));  
      //dispatch(push(`/${locale}/`));
    },
    reactiveUser: (username, email, adminUsername, props, selectItem) => {
      dispatch(actions.reactiveUser(username, email, adminUsername)).then(
        setTimeout(() => {
          // selectItem({});
          // win.getusersList(username)
          window.location.reload()();
        }, 1000)
      );
    }
  };
};

const Datafactorymanagement = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Datafactorymanagement;



// WEBPACK FOOTER //
// ./src/components/container/Datafactorymanagement/index.js